import styled from 'styled-components';

export const Wrapper = styled.div`
    background-color:  ${(props) => props.theme.backgroundDarkColor};
    padding-top: 1em;
    position:relative;
    z-index:0;
`;

export const IntroWrapper = styled.div`
  //padding: 2rem 0;
  display: flex;
  align-items: left;
  justify-content: left;
  flex-direction: row;

  @media (max-width: 960px) {
    flex-direction: column;
    background-image: none;
    position: relative;
    &:after{
      content:'';
      background-image: none;
    }
  }
`;

export const Social = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: baseline;
  list-style: none;
  li{
    padding: 0 0.5em;
  }
  @media (max-width: 960px){
    align-self: flex-end;
    //padding: 0 2em;
  }
  @media (max-width: 660px){
    align-self: center;
    //padding: 0 2em;
  }
 
`;

export const HeaderBottom = styled.div`
  @media (max-width: 960px){
    display:flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  }
  @media (max-width: 660px){
    align-items: flex-start;
    flex-direction: column;
  }
  
`;

export const Text = styled.p`
  margin-top:0.5em;
  line-height:1.15em;
  color: ${(props) => props.theme.backgroundLighterColor};
  br{
  content: "";
    margin: 2em;
    display: block;
    font-size: 1rem;
  }
  @media (max-width: 960px) {
      text-align: left;
    }
`;

export const FooterBottom = styled.div`
    display:flex;
    padding-top:1em;
    padding-bottom: 2em;
    width: 100%;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    text-align: center;
    border-top: 1px solid #555;
    @media(max-width: 960px) {
      flex-direction: column;
    }
    p{
      color: #888;
    }
    a {
      color: #888;
    }
`;
